import Image from "@/services/Image"

export function getAll(items) {
    let result = []

    Object.values(items).forEach(value => {
        result.push({
            id: value?.id,
            name: value?.name,
            avatar: {
                host: value?.avatar_host,
                name: value?.avatar_name,
            },
        })
    })

    return result
}

export function getImage(host, name, w = null, h = null) {
    if (host && name) {
      return Image.handle(host, name, w, h)
    }
    return "/assets/static/user/no_image.jpg"
}
